export default (messageId) => {
  const tempInput = document.createElement("input");
  tempInput.value = messageId;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
}
